// extracted by mini-css-extract-plugin
export var centerText = "_cz-8";
export var container = "_cz-0";
export var doughnutContainer = "_cz-7";
export var legend = "_cz-a";
export var legendItemColorDisplay = "_cz-b";
export var legendItemLabel = "_cz-d";
export var legendItemValue = "_cz-c";
export var lg = "_cz-5";
export var maxWidth = "_cz-9";
export var md = "_cz-4";
export var responsive = "_cz-6";
export var sm = "_cz-3";
export var xs = "_cz-2";
export var xxs = "_cz-1";